export const ERROR_CODE_ABORTED = 'ERROR_CODE_ABORTED';

export const uploadWithProgress = <T>(
  url: string,
  formData: FormData,
  onProgress?: (progress: number) => void,
  signal?: AbortSignal
): Promise<T> => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    const onAbort = () => {
      xhr.abort();
    };

    if (signal?.aborted) {
      reject(new Error(ERROR_CODE_ABORTED));
      return;
    }
    signal?.addEventListener('abort', onAbort);

    xhr.withCredentials = true;

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const progress = Math.round((event.loaded / event.total) * 100);
        onProgress?.(progress);
      }
    });

    xhr.addEventListener('load', () => {
      signal?.removeEventListener('abort', onAbort);
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const response = JSON.parse(xhr.responseText) as { payload: T };
          onProgress?.(100);
          resolve(response.payload);
        } catch (error) {
          reject(
            new Error('Failed to parse response: ' + (error as Error).message)
          );
        }
      } else {
        try {
          const errorResponse = JSON.parse(xhr.responseText);
          reject(
            new Error(
              errorResponse.error?.message ||
                `Upload failed with status ${xhr.status}`
            )
          );
        } catch {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      }
    });

    xhr.addEventListener('error', () => {
      signal?.removeEventListener('abort', onAbort);
      reject(new Error('Network error during upload'));
    });

    xhr.addEventListener('abort', () => {
      signal?.removeEventListener('abort', onAbort);
      reject(new Error(ERROR_CODE_ABORTED));
    });

    xhr.open('POST', url, true);
    xhr.send(formData);
  });
};
